module.exports = __webpack_public_path__ + "static/media/loginlogo.d2471620.PNG";